<template>
    <transition  name="el-fade-in-linear">
        <div class="l-loading" :class="!isFullScreen ? 'full-parent' : ''" v-if="loading">
            <div class="l-loading-content">
                <img class="img" src="https://bigdata.topeti.com/PCRepository/middleground/loading.gif" alt="">
                <div class="title">{{ text }}</div>
            </div>
        </div>
    </transition >
</template>

<script>
export default {
    // 组件名称
    name: 'customLoading',
    // 组件参数 接收来自父组件的数据
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: '正在加载中，请稍候'
        },
        isFullScreen: {
            type: Boolean,
            default: true
        }
    },
    // 局部注册的组件
    components: {},
    // 组件状态值
    data() {
        return {}
    },
    // 计算属性
    computed: {},
    // 侦听器
    watch: {},
    // 组件方法
    methods: {},
}
</script>

<style scoped lang="scss">

.l-loading.full-parent {
    width: 100%;
    height: 100%;
}

.l-loading {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #fff;
    z-index: 99999;
    &-content {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
        .img {
            display: block;
            transform: scale(0.05);
        }
        .title {
            color: #333333;
            font-weight: 400;
            font-size: 12px;
            position: absolute;
            left: 50%;
            top: 55%;
            transform: translate(-50%,-50%);
        }
    }
}
</style>
